module.exports = __webpack_public_path__ + "img/infra.417c73d9.png";